import { useState } from "react";
import { cn } from "@/lib/cn";

/*
  Logo files are downloaded from wtclisboa.com:
   - /wtc-logo.svg       → white version (default, used on dark UI)
   - /wtc-logo-black.svg → dark version (#231f20, for light surfaces)
*/

type Props = {
  tone?: "white" | "black";
  className?: string;
  style?: React.CSSProperties;
};

export function WTCLogo({ tone = "white", className, style }: Props) {
  const [failed, setFailed] = useState(false);
  const src = tone === "white" ? "/wtc-logo.svg" : "/wtc-logo-black.svg";

  if (failed) {
    return <Wordmark className={className} style={style} />;
  }

  return (
    <img
      src={src}
      alt="World Trade Center Lisboa"
      className={cn("block h-7 w-auto", className)}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}

function Wordmark({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return (
    <span
      className={cn("inline-block text-base font-semibold tracking-[0.18em] text-white", className)}
      style={style}
    >
      WTC LISBOA
    </span>
  );
}
